var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 200,
    viewBox: "0 0 156 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.0481 195.716L86.9219 188.615V184.643L99.0481 191.624V195.716Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0488 195.718L109.494 189.579V185.486L99.0488 191.625V195.718Z",
    fill: "#343434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9219 184.644L97.3672 178.505L109.493 185.486L99.0481 191.625L86.9219 184.644Z",
    fill: "#BBBBBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.552 169.358L132.426 162.377V158.284L144.552 165.265V169.358Z",
    fill: "#595959"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.553 169.358L154.998 163.34V159.247L144.553 165.265V169.358Z",
    fill: "#343434"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.426 158.284L142.871 152.266L154.997 159.247L144.552 165.265L132.426 158.284Z",
    fill: "#BBBBBB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.259 157.56L21.1328 150.579V146.606L33.259 153.467V157.56Z",
    fill: "#595959"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2598 157.561L43.7051 151.543V147.45L33.2598 153.469V157.561Z",
    fill: "#343434"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1328 146.607L31.5782 140.469L43.7044 147.45L33.259 153.468L21.1328 146.607Z",
    fill: "#BBBBBB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0526 191.745L21.1328 146.607V32.499L99.0526 77.6367V191.745Z",
    fill: "url(#paint0_linear_335_6128)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6785 162.978L39.3789 140.83V54.7676L77.6785 76.9151V162.978Z",
    fill: "#343434"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7011 138.302V57.2953L39.3789 54.7676V140.83L77.6785 162.978V158.043L43.7011 138.302Z",
    fill: "#F2F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7011 138.302L39.3789 140.349V54.7676L43.7011 57.2953V138.302Z",
    fill: "#BBBBBB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0488 191.744L154.997 159.245V45.1367L99.0488 77.6358V191.744Z",
    fill: "#343434"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0488 170.56L140.59 146.486V76.4326L99.0488 100.386V170.56Z",
    fill: "#BBBBBB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.182 97.8579L121.744 95.2099V87.2656L117.182 89.9137V97.8579Z",
    fill: "#A6A6A6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M121.384 87.5064V95.0895L117.182 97.4968V97.8579L121.744 95.2099V87.2656L121.384 87.5064Z",
    fill: "#D9D9D9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101.332 169.237L105.894 166.589V121.09L101.332 123.738V169.237Z",
    fill: "#343434"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.613 122.414V165.746L101.332 167.07V169.237L105.894 166.589V121.09L103.613 122.414Z",
    fill: "#595959"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M103.613 165.745L105.894 166.588L101.332 169.236V167.069L103.613 165.745Z",
    fill: "#737373"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1328 32.4991L77.0814 0L155.001 45.1376L99.0526 77.6367L21.1328 32.4991Z",
    fill: "#F2F2F2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5215 59.943L124.867 31.416L148.279 45.1379L99.0535 73.6649L75.5215 59.943Z",
    fill: "#D9D9D9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M124.867 32.8604L147.198 45.8601L148.279 45.1378L124.867 31.416L75.5215 59.943L76.7221 60.6652L124.867 32.8604Z",
    fill: "#595959"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.094 94.2472L102.294 93.525V81.0068L101.094 81.729V94.2472Z",
    fill: "#1A1A1A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M101.694 81.3679V93.2843L101.094 93.6454V94.2472L102.294 93.525V81.0068L101.694 81.3679Z",
    fill: "#595959"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M101.694 93.2852L102.294 93.5259L101.094 94.2481V93.6463L101.694 93.2852Z",
    fill: "#737373"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M104.215 92.4415L105.415 91.7193V79.2012L104.215 79.9233V92.4415Z",
    fill: "#1A1A1A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M104.815 79.5623V91.4786L104.215 91.8397V92.4415L105.415 91.7193V79.2012L104.815 79.5623Z",
    fill: "#595959"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M104.815 91.4795L105.415 91.7202L104.215 92.4425V91.8406L104.815 91.4795Z",
    fill: "#737373"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M107.336 90.6359L108.537 89.9137V77.3955L107.336 78.1177V90.6359Z",
    fill: "#1A1A1A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M107.936 77.7566V89.6729L107.336 90.034V90.6359L108.537 89.9137V77.3955L107.936 77.7566Z",
    fill: "#595959"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M107.936 89.6738L108.537 89.9146L107.336 90.6368V90.035L107.936 89.6738Z",
    fill: "#737373"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M110.336 88.8283L111.657 88.1061V75.5879L110.336 76.4304V88.8283Z",
    fill: "#1A1A1A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M111.056 76.0694V87.8653L110.336 88.2264V88.8283L111.657 88.1061V75.5879L111.056 76.0694Z",
    fill: "#595959"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M111.056 87.8662L111.657 88.107L110.336 88.8292V88.2273L111.056 87.8662Z",
    fill: "#737373"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M113.459 87.1447L114.78 86.3021V73.9043L113.459 74.6265V87.1447Z",
    fill: "#1A1A1A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M114.059 74.2654V86.1817L113.459 86.5428V87.1447L114.78 86.3021V73.9043L114.059 74.2654Z",
    fill: "#595959"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M114.059 86.1816L114.78 86.302L113.459 87.1446V86.5427L114.059 86.1816Z",
    fill: "#737373"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M116.58 85.34L117.781 84.6178V72.0996L116.58 72.8218V85.34Z",
    fill: "#1A1A1A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M117.18 72.4607V84.3771L116.58 84.7381V85.34L117.781 84.6178V72.0996L117.18 72.4607Z",
    fill: "#595959"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M117.18 84.3779L117.781 84.6187L116.58 85.3409V84.739L117.18 84.3779Z",
    fill: "#737373"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M119.701 83.5324L120.902 82.8102V70.292L119.701 71.0142V83.5324Z",
    fill: "#1A1A1A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M120.301 70.6531V82.5694L119.701 82.9305V83.5324L120.902 82.8102V70.292L120.301 70.6531Z",
    fill: "#595959"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M120.301 82.5703L120.902 82.8111L119.701 83.5332V82.9314L120.301 82.5703Z",
    fill: "#737373"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M122.703 81.7287L124.024 81.0065V68.4883L122.703 69.2105V81.7287Z",
    fill: "#1A1A1A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M123.424 68.8494V80.7657L122.703 81.1268V81.7287L124.024 81.0065V68.4883L123.424 68.8494Z",
    fill: "#595959"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M123.424 80.7666L124.024 81.0074L122.703 81.7295V81.1277L123.424 80.7666Z",
    fill: "#737373"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M125.826 79.924L127.147 79.2018V66.6836L125.826 67.4058V79.924Z",
    fill: "#1A1A1A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M126.426 67.0447V78.961L125.826 79.3221V79.924L127.147 79.2018V66.6836L126.426 67.0447Z",
    fill: "#595959"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M126.426 78.9619L127.147 79.2027L125.826 79.9248V79.323L126.426 78.9619Z",
    fill: "#737373"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M128.947 78.1164L130.148 77.3942V64.876L128.947 65.5982V78.1164Z",
    fill: "#1A1A1A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M129.548 65.2371V77.1534L128.947 77.5145V78.1164L130.148 77.3942V64.876L129.548 65.2371Z",
    fill: "#595959"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M129.548 77.1543L130.148 77.395L128.947 78.1172V77.5154L129.548 77.1543Z",
    fill: "#737373"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M132.064 76.3117L133.265 75.5895V63.0713L132.064 63.7935V76.3117Z",
    fill: "#1A1A1A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M132.665 63.4324V75.3487L132.064 75.7098V76.3117L133.265 75.5895V63.0713L132.665 63.4324Z",
    fill: "#595959"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M132.665 75.3496L133.265 75.5904L132.064 76.3125V75.7107L132.665 75.3496Z",
    fill: "#737373"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M135.189 74.507L136.39 73.7848V61.2666L135.189 61.9888V74.507Z",
    fill: "#1A1A1A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M135.79 61.6277V73.5441L135.189 73.9051V74.507L136.39 73.7848V61.2666L135.79 61.6277Z",
    fill: "#595959"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M135.79 73.5449L136.39 73.7857L135.189 74.5078V73.906L135.79 73.5449Z",
    fill: "#737373"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M138.191 72.7003L139.512 71.9782V59.46L138.191 60.1822V72.7003Z",
    fill: "#1A1A1A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M138.912 59.8211V71.7374L138.191 72.0985V72.7003L139.512 71.9782V59.46L138.912 59.8211Z",
    fill: "#595959"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M138.912 71.7383L139.512 71.979L138.191 72.7012V72.0994L138.912 71.7383Z",
    fill: "#737373"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5137 51.0337L61.8343 50.3115L72.6399 56.5706L71.3192 57.2928L60.5137 51.0337Z",
    fill: "#1A1A1A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9195 56.9317L61.7143 51.0337L60.9939 51.3948L60.5137 51.0337L61.8343 50.3115L72.6399 56.5706L71.9195 56.9317Z",
    fill: "#595959"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7143 51.0337L61.8343 50.3115L60.5137 51.0337L60.9939 51.3948L61.7143 51.0337Z",
    fill: "#737373"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6348 49.23L64.8354 48.5078L75.6409 54.7669L74.4403 55.4891L63.6348 49.23Z",
    fill: "#1A1A1A"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0406 55.128L64.7153 49.23L64.115 49.5911L63.6348 49.23L64.8354 48.5078L75.6409 54.7669L75.0406 55.128Z",
    fill: "#595959"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7153 49.23L64.8354 48.5078L63.6348 49.23L64.115 49.5911L64.7153 49.23Z",
    fill: "#737373"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7539 47.5445L67.9545 46.8223L78.76 52.961L77.5594 53.6832L66.7539 47.5445Z",
    fill: "#1A1A1A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1597 53.3221L67.8345 47.4241L67.2342 47.7852L66.7539 47.5445L67.9545 46.8223L78.76 52.961L78.1597 53.3221Z",
    fill: "#595959"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8345 47.4241L67.9545 46.8223L66.7539 47.5445L67.2342 47.7852L67.8345 47.4241Z",
    fill: "#737373"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7578 45.7388L71.0785 45.0166L81.884 51.2757L80.5633 51.9979L69.7578 45.7388Z",
    fill: "#1A1A1A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2837 51.6368L70.9584 45.6184L70.3581 45.9796L69.7578 45.7388L71.0785 45.0166L81.884 51.2757L81.2837 51.6368Z",
    fill: "#595959"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9584 45.6184L71.0785 45.0166L69.7578 45.7388L70.3581 45.9796L70.9584 45.6184Z",
    fill: "#737373"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8789 43.9341L74.1996 43.2119L85.0051 49.471L83.6844 50.1932L72.8789 43.9341Z",
    fill: "#1A1A1A"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2847 49.8321L74.0795 43.8137L73.4792 44.1749L72.8789 43.9341L74.1996 43.2119L85.0051 49.471L84.2847 49.8321Z",
    fill: "#595959"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0795 43.8137L74.1996 43.2119L72.8789 43.9341L73.4792 44.1749L74.0795 43.8137Z",
    fill: "#737373"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M76 42.1265L77.3207 41.4043L88.1262 47.6634L86.8055 48.3856L76 42.1265Z",
    fill: "#1A1A1A"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4058 48.0245L77.2006 42.0061L76.4802 42.3673L76 42.1265L77.3207 41.4043L88.1262 47.6634L87.4058 48.0245Z",
    fill: "#595959"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2006 42.0061L77.3207 41.4043L76 42.1265L76.4802 42.3673L77.2006 42.0061Z",
    fill: "#737373"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1211 40.3208L80.3217 39.5986L91.1272 45.8577L89.9266 46.5799L79.1211 40.3208Z",
    fill: "#1A1A1A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5269 46.2188L80.2016 40.2005L79.6013 40.5616L79.1211 40.3208L80.3217 39.5986L91.1272 45.8577L90.5269 46.2188Z",
    fill: "#595959"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2016 40.2005L80.3217 39.5986L79.1211 40.3208L79.6013 40.5616L80.2016 40.2005Z",
    fill: "#737373"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2441 38.5162L83.4448 37.7939L94.2503 44.053L93.0497 44.7753L82.2441 38.5162Z",
    fill: "#1A1A1A"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M93.65 44.4141L83.3247 38.5162L82.7244 38.8773L82.2441 38.5162L83.4448 37.7939L94.2503 44.053L93.65 44.4141Z",
    fill: "#595959"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3247 38.5162L83.4448 37.7939L82.2441 38.5162L82.7244 38.8773L83.3247 38.5162Z",
    fill: "#737373"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2461 36.7105L86.5668 35.9883L97.3723 42.2474L96.0516 42.9696L85.2461 36.7105Z",
    fill: "#1A1A1A"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M96.772 42.6085L86.4467 36.7105L85.8464 37.0716L85.2461 36.7105L86.5668 35.9883L97.3723 42.2474L96.772 42.6085Z",
    fill: "#595959"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4467 36.7105L86.5668 35.9883L85.2461 36.7105L85.8464 37.0716L86.4467 36.7105Z",
    fill: "#737373"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3672 34.9058L89.6879 34.1836L100.493 40.4427L99.1727 41.1649L88.3672 34.9058Z",
    fill: "#1A1A1A"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8931 40.8038L89.5678 34.9058L88.9675 35.2669L88.3672 34.9058L89.6879 34.1836L100.493 40.4427L99.8931 40.8038Z",
    fill: "#595959"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5678 34.9058L89.6879 34.1836L88.3672 34.9058L88.9675 35.2669L89.5678 34.9058Z",
    fill: "#737373"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4883 33.0992L92.809 32.377L103.614 38.6361L102.294 39.3583L91.4883 33.0992Z",
    fill: "#1A1A1A"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M102.894 38.9971L92.6889 33.0992L91.9685 33.4603L91.4883 33.0992L92.809 32.377L103.614 38.6361L102.894 38.9971Z",
    fill: "#595959"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6889 33.0992L92.809 32.377L91.4883 33.0992L91.9685 33.4603L92.6889 33.0992Z",
    fill: "#737373"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6094 31.4146L95.81 30.6924L106.616 36.8311L105.415 37.6737L94.6094 31.4146Z",
    fill: "#1A1A1A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M106.015 37.3126L95.6899 31.2942L95.0896 31.6553L94.6094 31.4146L95.81 30.6924L106.616 36.8311L106.015 37.3126Z",
    fill: "#595959"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6899 31.2942L95.81 30.6924L94.6094 31.4146L95.0896 31.6553L95.6899 31.2942Z",
    fill: "#737373"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7285 29.6089L98.9291 28.8867L109.735 35.1458L108.534 35.868L97.7285 29.6089Z",
    fill: "#1A1A1A"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M109.134 35.5069L98.8091 29.4886L98.2088 29.8497L97.7285 29.6089L98.9291 28.8867L109.735 35.1458L109.134 35.5069Z",
    fill: "#595959"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8091 29.4886L98.9291 28.8867L97.7285 29.6089L98.2088 29.8497L98.8091 29.4886Z",
    fill: "#737373"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M104.689 25.397L105.89 24.6748L116.696 30.9339L115.495 31.6561L104.689 25.397Z",
    fill: "#1A1A1A"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M116.095 31.295L105.77 25.397L105.17 25.7581L104.689 25.397L105.89 24.6748L116.696 30.9339L116.095 31.295Z",
    fill: "#595959"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M105.77 25.397L105.89 24.6748L104.689 25.397L105.17 25.7581L105.77 25.397Z",
    fill: "#737373"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M107.816 23.5923L109.017 22.8701L119.823 29.1292L118.622 29.8514L107.816 23.5923Z",
    fill: "#1A1A1A"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M119.222 29.4903L108.897 23.5923L108.297 23.9534L107.816 23.5923L109.017 22.8701L119.823 29.1292L119.222 29.4903Z",
    fill: "#595959"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M108.897 23.5923L109.017 22.8701L107.816 23.5923L108.297 23.9534L108.897 23.5923Z",
    fill: "#737373"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7221 60.6652L75.5215 59.943L124.867 31.416V32.8604L76.7221 60.6652Z",
    fill: "#343434"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1758 120.849H35.4159C35.656 120.488 35.8961 120.247 36.3764 119.886C38.0573 118.923 40.6986 118.923 42.2594 119.886C42.7396 120.127 43.0998 120.488 43.2199 120.849H43.46V127.108C43.46 127.71 42.9798 128.312 42.2594 128.793C40.5785 129.756 37.9372 129.756 36.3764 128.793C35.536 128.312 35.1758 127.71 35.1758 127.108V120.849Z",
    fill: "url(#paint1_linear_335_6128)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3762 122.655C38.0571 123.618 40.6984 123.618 42.2592 122.655C43.9401 121.692 43.9401 120.128 42.2592 119.165C40.5783 118.202 37.937 118.202 36.3762 119.165C34.8154 120.128 34.6953 121.692 36.3762 122.655Z",
    fill: "#808080"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1758 118.922H35.4159C35.656 118.561 35.8961 118.321 36.3764 117.96C38.0573 116.997 40.6986 116.997 42.2594 117.96C42.7396 118.2 43.0998 118.561 43.2199 118.922H43.46V121.932C43.46 122.533 42.9798 123.135 42.2594 123.617C40.5785 124.58 37.9372 124.58 36.3764 123.617C35.536 123.135 35.1758 122.533 35.1758 121.932V118.922Z",
    fill: "url(#paint2_linear_335_6128)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3762 120.729C38.0571 121.691 40.6984 121.691 42.2592 120.729C43.9401 119.766 43.9401 118.201 42.2592 117.238C40.5783 116.275 37.937 116.275 36.3762 117.238C34.8154 118.321 34.6953 119.766 36.3762 120.729Z",
    fill: "#808080"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4629 124.703H46.703C46.9431 124.342 47.1833 124.101 47.6635 123.74C49.3444 122.777 51.9857 122.777 53.5465 123.74C54.0268 123.981 54.3869 124.342 54.507 124.703H54.7471V130.962C54.7471 131.564 54.2669 132.165 53.5465 132.647C51.8657 133.61 49.2243 133.61 47.6635 132.647C46.8231 132.165 46.4629 131.564 46.4629 130.962V124.703Z",
    fill: "url(#paint3_linear_335_6128)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6628 126.387C49.3436 127.35 51.985 127.35 53.5458 126.387C55.2267 125.424 55.2267 123.859 53.5458 122.896C51.8649 121.933 49.2236 121.933 47.6628 122.896C46.102 123.979 46.102 125.544 47.6628 126.387Z",
    fill: "#808080"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4629 122.775H46.703C46.9431 122.414 47.1833 122.173 47.6635 121.812C49.3444 120.849 51.9857 120.849 53.5465 121.812C54.0268 122.053 54.3869 122.414 54.507 122.775H54.7471V125.784C54.7471 126.386 54.2669 126.988 53.5465 127.469C51.8657 128.432 49.2243 128.432 47.6635 127.469C46.8231 126.988 46.4629 126.386 46.4629 125.784V122.775Z",
    fill: "url(#paint4_linear_335_6128)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6628 124.581C49.3436 125.544 51.985 125.544 53.5458 124.581C55.2267 123.618 55.2267 122.053 53.5458 121.09C51.8649 120.127 49.2236 120.127 47.6628 121.09C46.102 122.053 46.102 123.618 47.6628 124.581Z",
    fill: "#808080"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2188 102.914H35.0592C35.7795 101.71 36.9802 100.507 38.7811 99.5438C44.7842 96.0531 54.5091 96.0531 60.5122 99.5438C62.1931 100.507 63.5137 101.71 64.2341 103.034H65.0745V116.877C64.9545 119.164 63.5137 121.33 60.5122 123.015C54.5091 126.506 44.7842 126.506 38.7811 123.015C35.7796 121.33 34.3388 119.043 34.3388 116.756V102.914H34.2188Z",
    fill: "url(#paint5_linear_335_6128)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6593 109.414C44.6623 112.904 54.3873 112.904 60.3904 109.414C66.3935 105.923 66.3935 100.266 60.5105 96.7752C54.5074 93.2846 44.7824 93.2846 38.7793 96.7752C32.6562 100.386 32.6562 105.923 38.6593 109.414Z",
    fill: "#808080"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9345 87.0264H32.895C33.7354 85.582 35.1762 84.258 37.0972 83.0543C44.0607 79.0822 55.2264 79.0822 62.0699 83.0543C64.111 84.258 65.4316 85.582 66.2721 87.0264H67.1125V103.035C66.9924 105.563 65.3116 108.211 61.9499 110.137C54.9863 114.109 43.8206 114.109 36.9771 110.137C33.6154 108.211 31.8145 105.563 31.8145 103.035L31.9345 87.0264Z",
    fill: "url(#paint6_linear_335_6128)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9773 94.6087C43.8208 98.5808 54.9865 98.5808 61.95 94.6087C68.9136 90.6366 68.9136 84.1367 62.0701 80.1646C55.2266 76.1925 44.0609 76.1925 37.0973 80.1646C30.2538 84.1367 30.1338 90.6366 36.9773 94.6087Z",
    fill: "#808080"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0841 147.45L78.4033 136.737H71.6798L69.999 147.45C69.999 147.57 69.8789 147.811 69.8789 147.931C69.8789 148.533 70.2391 149.135 70.9595 149.737C72.6403 151.061 75.882 151.302 78.2832 150.218C79.6039 149.617 80.3243 148.774 80.3243 147.811C80.2042 147.811 80.2042 147.57 80.0841 147.45Z",
    fill: "url(#paint7_linear_335_6128)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4031 136.738C78.4031 137.34 77.9229 137.941 77.0824 138.303C75.6417 138.904 73.4806 138.784 72.4001 137.941C71.9198 137.58 71.6797 137.219 71.6797 136.738C71.6797 136.136 72.1599 135.534 73.0004 135.173C74.4411 134.571 76.6022 134.692 77.6828 135.534C78.163 135.895 78.4031 136.377 78.4031 136.738Z",
    fill: "#9C9C9C"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4854 103.396V116.155C85.4854 118.563 84.2847 120.729 82.2437 121.933L78.4017 124.22C77.6814 124.701 77.2011 125.424 77.2011 126.266V136.497C77.2011 136.859 76.961 137.22 76.3607 137.46C75.4002 137.821 74.0795 137.821 73.3592 137.22C72.999 136.979 72.8789 136.738 72.8789 136.497V126.266C72.8789 123.859 74.0795 121.692 76.1206 120.489L79.8425 118.202C80.5628 117.72 81.0431 116.998 81.0431 116.155V103.396H85.4854Z",
    fill: "#EFEFEF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4802 137.22V126.988C73.4802 124.581 74.6809 122.414 76.7219 121.211L80.4438 118.924C81.1642 118.442 81.6444 117.72 81.6444 116.878V104.119H85.4864V103.396H81.1642V116.155C81.1642 116.998 80.6839 117.841 79.9636 118.202L76.2417 120.489C74.2006 121.692 73 123.979 73 126.266V136.497C73 136.859 73.1201 137.099 73.4802 137.22C73.4802 137.34 73.4802 137.34 73.4802 137.22Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0526 77.6367L21.1328 32.499L24.6146 55.4891L62.9142 77.757L99.0526 77.6367Z",
    fill: "#F2F2F2"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M62.916 109.894V77.7561L99.0545 77.6357V109.774L62.916 109.894Z",
    fill: "#BDBDBD"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6152 87.7476V55.4893L62.9148 77.7572V109.895L24.6152 87.7476Z",
    fill: "#E7E7E7"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1328 64.7574V32.499L24.6146 55.4891V87.7475L21.1328 64.7574Z",
    fill: "#BDBDBD"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5915 166.106L21.1308 142.635L11.766 148.051C9.24472 149.496 7.08362 151.06 5.40276 152.746L0 151.542V163.94C0 167.31 1.5608 170.44 4.68239 173.208C5.64289 174.171 6.8435 175.014 8.28424 175.736L41.9014 195.235C54.1477 202.337 75.5186 201.374 89.5658 193.189L98.9306 187.772V174.893L61.5915 166.106Z",
    fill: "url(#paint8_linear_335_6128)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9008 182.357L8.28359 162.858C-3.96267 155.756 -2.40187 143.358 11.7654 135.293L21.1302 129.877L99.05 175.015L89.6852 180.431C75.518 188.616 54.147 189.459 41.9008 182.357Z",
    fill: "#F2F2F2"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6736 183.8C55.2298 183.8 48.5064 182.235 43.5838 179.467L9.96666 159.968C6.96512 158.282 3.36328 155.273 3.36328 150.94C3.36328 146.486 6.96512 141.913 13.3284 138.181L21.0123 133.728L92.2087 175.013L87.8865 177.541C81.043 181.513 71.7983 183.8 62.6736 183.8Z",
    fill: "#4D4D4D"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8108 142.875L18.6056 136.977C18.0053 136.616 18.1254 136.135 18.7257 135.774L18.8457 135.653C19.446 135.292 20.4065 135.292 21.0068 135.533L31.2121 141.431C31.8124 141.792 31.6923 142.274 31.092 142.635L30.9719 142.755C30.3716 143.236 29.4111 143.237 28.8108 142.875Z",
    fill: "#343434"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9007 153.95L37.6955 148.052C37.0951 147.691 37.2152 147.209 37.8155 146.848L37.9356 146.728C38.5359 146.366 39.4964 146.367 40.0967 146.607L50.3019 152.505C50.9022 152.866 50.7821 153.348 50.1818 153.709L50.0618 153.829C49.3414 154.19 48.3809 154.19 47.9007 153.95Z",
    fill: "#343434"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8694 164.903L56.6642 159.005C56.0639 158.644 56.184 158.162 56.7843 157.801L56.9043 157.681C57.5046 157.32 58.4651 157.32 59.0654 157.56L69.2706 163.458C69.871 163.819 69.7509 164.301 69.1506 164.662L69.0305 164.782C68.4302 165.143 67.4697 165.264 66.8694 164.903Z",
    fill: "#343434"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9632 175.976L75.758 170.078C75.1576 169.717 75.2777 169.235 75.878 168.874L75.9981 168.754C76.5984 168.393 77.5589 168.393 78.1592 168.634L88.3644 174.532C88.9647 174.893 88.8446 175.374 88.2443 175.735L88.1243 175.856C87.4039 176.217 86.4434 176.217 85.9632 175.976Z",
    fill: "#343434"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0901 149.254L8.88491 143.356C8.2846 142.995 8.40466 142.514 9.00497 142.153L9.12503 142.032C9.72533 141.671 10.6858 141.671 11.2861 141.912L21.4914 147.81C22.0917 148.171 21.9716 148.652 21.3713 149.014L21.2512 149.134C20.5309 149.615 19.5704 149.615 19.0901 149.254Z",
    fill: "#343434"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0589 160.329L27.8537 154.431C27.2534 154.069 27.3734 153.588 27.9737 153.227L28.0938 153.107C28.6941 152.745 29.6546 152.745 30.2549 152.986L40.4601 158.884C41.0604 159.245 40.9403 159.727 40.34 160.088L40.22 160.208C39.6197 160.569 38.6592 160.569 38.0589 160.329Z",
    fill: "#343434"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1507 171.282L46.9455 165.384C46.3451 165.023 46.4652 164.541 47.0655 164.18L47.1856 164.06C47.7859 163.699 48.7464 163.699 49.3467 163.939L59.5519 169.837C60.1522 170.198 60.0321 170.68 59.4318 171.041L59.3118 171.161C58.5914 171.643 57.6309 171.643 57.1507 171.282Z",
    fill: "#343434"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8808 181.392C77.9203 181.753 76.9598 181.994 75.8793 182.234L65.9142 176.457C65.3139 176.096 65.434 175.614 66.0343 175.253H66.1543C66.7546 174.892 67.7151 174.892 68.3154 175.133L78.5206 181.031C78.7608 181.031 78.8808 181.271 78.8808 181.392Z",
    fill: "#343434"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5267 140.828C16.8064 141.309 15.8459 141.309 15.2456 140.948L12.0039 139.022C12.4842 138.661 12.9644 138.42 13.4446 138.18L14.4051 137.698L17.7669 139.624C18.127 139.865 18.127 140.467 17.5267 140.828Z",
    fill: "#343434"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4944 151.541L23.2892 145.643C22.6889 145.282 22.809 144.801 23.4093 144.44L23.5293 144.319C24.1296 143.958 25.0901 143.958 25.6904 144.199L35.8956 150.097C36.496 150.458 36.3759 150.94 35.7756 151.301L35.6555 151.421C35.0552 151.903 34.0947 151.903 33.4944 151.541Z",
    fill: "#343434"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8636 162.134L41.6583 156.236C41.058 155.875 41.1781 155.394 41.7784 155.033L41.8985 154.912C42.4988 154.551 43.4593 154.551 44.0596 154.792L54.2648 160.69C54.8651 161.051 54.745 161.532 54.1447 161.893L54.0247 162.014C53.3043 162.495 52.3438 162.495 51.8636 162.134Z",
    fill: "#343434"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1136 172.846L59.9083 166.948C59.308 166.587 59.4281 166.106 60.0284 165.744L60.1485 165.624C60.7488 165.263 61.7093 165.263 62.3096 165.504L72.5148 171.402C73.1151 171.763 72.995 172.244 72.3947 172.605L72.2747 172.726C71.6744 173.087 70.7139 173.087 70.1136 172.846Z",
    fill: "#343434"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4812 178.865C84.6407 179.346 83.6802 179.707 82.7198 180.068L78.2775 177.541C77.6772 177.18 77.7972 176.698 78.3976 176.337H78.5176C79.1179 175.976 80.0784 175.976 80.6787 176.217L85.4812 178.865Z",
    fill: "#343434"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5626 157.441C12.8423 157.922 11.8818 157.922 11.2815 157.561L3.71761 153.228C3.47748 152.506 3.35742 151.663 3.35742 150.941C3.35742 150.7 3.35742 150.58 3.35742 150.339H3.47749L13.6827 156.237C14.283 156.478 14.1629 157.079 13.5626 157.441Z",
    fill: "#343434"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3714 168.634L20.1662 162.736C19.5658 162.375 19.6859 161.894 20.2862 161.533L20.4063 161.412C21.0066 161.051 21.9671 161.051 22.5674 161.292L32.7726 167.19C33.3729 167.551 33.2528 168.032 32.6525 168.393L32.5325 168.514C31.8121 168.875 30.8516 168.995 30.3714 168.634Z",
    fill: "#343434"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3421 179.588L39.1369 173.69C38.5366 173.329 38.6566 172.848 39.2569 172.487L39.377 172.366C39.9773 172.005 40.9378 172.005 41.5381 172.246L51.7433 178.144C52.3436 178.505 52.2236 178.986 51.6232 179.348L51.5032 179.468C50.9029 179.949 49.9424 179.949 49.3421 179.588Z",
    fill: "#343434"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3462 183.801C60.2657 183.801 59.1851 183.68 58.2246 183.68L58.3447 183.56L58.4647 183.439C59.065 183.078 60.0255 183.078 60.6258 183.319L61.3462 183.801Z",
    fill: "#343434"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72399 149.134C9.00363 149.616 8.04314 149.616 7.44283 149.255L4.20117 147.329C4.44129 146.606 4.92154 145.884 5.40179 145.162L9.96412 147.81C10.4444 148.171 10.3243 148.773 9.72399 149.134Z",
    fill: "#343434"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8128 159.846L15.6076 153.948C15.0073 153.587 15.1273 153.106 15.7276 152.744L15.8477 152.624C16.448 152.263 17.4085 152.263 18.0088 152.504L28.214 158.402C28.8143 158.763 28.6943 159.244 28.0939 159.605L27.9739 159.726C27.2535 160.207 26.293 160.207 25.8128 159.846Z",
    fill: "#343434"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0608 170.56L33.8556 164.662C33.2553 164.301 33.3754 163.819 33.9757 163.458L34.0957 163.338C34.696 162.977 35.6565 162.977 36.2568 163.218L46.4621 169.116C47.0624 169.477 46.9423 169.958 46.342 170.319L46.2219 170.44C45.6216 170.801 44.6611 170.801 44.0608 170.56Z",
    fill: "#343434"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M62.43 181.152L52.2248 175.254C51.6244 174.893 51.7445 174.411 52.3448 174.05L52.4649 173.93C53.0652 173.569 54.0257 173.569 54.626 173.809L64.8312 179.707C65.4315 180.068 65.3114 180.55 64.7111 180.911L64.5911 181.031C63.8707 181.392 62.9102 181.393 62.43 181.152Z",
    fill: "#343434"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2918 164.059C27.2539 166.346 33.7372 166.346 37.8193 164.059C41.9013 161.772 41.9013 157.92 37.8193 155.633C33.8572 153.346 27.3739 153.346 23.2918 155.633C19.3298 157.92 19.3298 161.652 23.2918 164.059Z",
    fill: "#BFBFBF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7305 140.827H42.5026V157.919C42.3826 159.604 41.1819 161.169 39.0208 162.493C34.3384 165.141 26.8946 165.262 22.2122 162.493C20.0511 161.29 18.8505 159.604 18.7305 157.919V140.827Z",
    fill: "url(#paint9_linear_335_6128)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M22.213 145.642C26.8954 148.29 34.3392 148.29 39.0216 145.642C43.704 142.994 43.704 138.54 39.0216 135.892C34.3392 133.244 26.8954 133.244 22.213 135.892C17.5306 138.661 17.5306 142.994 22.213 145.642Z",
    fill: "#F2F2F2"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4997 147.086C33.6213 147.086 36.5028 146.364 38.6639 145.16C40.7049 143.956 41.9055 142.391 41.9055 140.706C41.9055 139.142 40.825 137.577 38.7839 136.373C36.6228 135.169 33.7413 134.447 30.7398 134.447C27.6182 134.447 24.7367 135.169 22.5756 136.373C20.5346 137.577 19.334 139.142 19.334 140.827C19.334 142.391 20.4145 143.956 22.4556 145.16C24.6167 146.364 27.4982 147.086 30.4997 147.086Z",
    fill: "#7D5E2F"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2128 145.041C22.3329 144.921 22.453 144.921 22.573 144.801C24.7341 143.597 27.6156 142.875 30.7372 142.875C33.7387 142.875 36.6202 143.597 38.7813 144.801C38.9014 144.921 39.0214 144.921 39.1415 145.041C40.9424 143.838 42.023 142.393 42.023 140.828C42.023 139.264 40.9424 137.699 38.9014 136.495C36.7403 135.292 33.8588 134.569 30.8573 134.569C27.7357 134.569 24.8542 135.292 22.6931 136.495C20.652 137.699 19.4514 139.264 19.4514 140.949C19.3314 142.393 20.2919 143.838 22.2128 145.041Z",
    fill: "url(#paint10_linear_335_6128)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4514 147.929C18.851 146.244 17.2903 144.92 15.4893 144.8C14.889 144.8 14.2887 144.8 13.6884 145.041C12.2477 145.402 10.927 146.365 10.2066 147.809C9.60632 149.253 9.72638 150.939 10.4468 152.383C11.1671 153.707 12.3677 154.79 13.8085 155.633C15.1291 156.355 16.6899 156.837 18.1307 157.318C18.3708 157.438 18.6109 157.318 18.851 157.679C18.9711 157.92 18.851 158.04 18.851 158.401C18.851 158.522 18.9711 158.642 19.0912 158.762C19.2112 158.883 19.3313 158.883 19.4514 158.762C19.8115 158.642 20.1717 158.401 20.2918 158.161C21.0122 156.836 19.6915 156.355 18.731 155.994C17.6504 155.633 16.5699 155.272 15.6094 154.67C14.6489 154.068 13.9285 153.105 13.6884 152.022C13.4483 150.939 13.8085 149.614 14.769 149.013C15.8495 148.29 17.2903 148.772 18.2507 149.614C18.6109 149.976 19.0912 150.698 19.4514 149.976C19.8115 149.374 19.5714 148.411 19.4514 147.929Z",
    fill: "#BFBFBF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7491 175.736C53.7871 178.023 47.3038 178.023 43.2217 175.736C39.1396 173.449 39.1396 169.597 43.2217 167.31C47.1837 165.023 53.6671 165.023 57.7491 167.31C61.7112 169.717 61.7112 173.449 57.7491 175.736Z",
    fill: "#BFBFBF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3112 152.505H38.5391V169.597C38.6591 171.282 39.8597 172.847 42.0208 174.171C46.7032 176.819 54.147 176.939 58.8294 174.171C60.9905 172.967 62.1912 171.282 62.3112 169.597V152.505Z",
    fill: "url(#paint11_linear_335_6128)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9512 157.44C54.2689 160.088 46.825 160.088 42.1427 157.44C37.4603 154.792 37.4603 150.338 42.1427 147.69C46.825 145.042 54.2689 145.042 58.9512 147.69C63.5136 150.338 63.5136 154.671 58.9512 157.44Z",
    fill: "#F2F2F2"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5445 158.884C47.4229 158.884 44.5414 158.161 42.3803 156.958C40.3393 155.754 39.1387 154.189 39.1387 152.504C39.1387 150.939 40.2192 149.375 42.2603 148.171C44.4214 146.967 47.3028 146.245 50.3044 146.245C53.426 146.245 56.3074 146.967 58.4686 148.171C60.5096 149.375 61.7102 150.939 61.7102 152.625C61.7102 154.189 60.6297 155.754 58.5886 156.958C56.4275 158.161 53.6661 158.884 50.5445 158.884Z",
    fill: "#7D5E2F"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3814 153.467C44.5425 152.264 47.4239 151.542 50.4255 151.542C53.5471 151.542 56.4285 152.264 58.5897 153.467C59.4301 153.949 60.1504 154.551 60.7508 155.153C61.4711 154.31 61.8313 153.467 61.8313 152.504C61.8313 150.819 60.6307 149.255 58.5897 148.051C56.4285 146.847 53.5471 146.125 50.4255 146.125C47.3039 146.125 44.5425 146.847 42.3814 148.051C40.3403 149.255 39.2598 150.819 39.2598 152.384C39.2598 153.347 39.62 154.19 40.3403 155.032C40.8206 154.551 41.4209 153.949 42.3814 153.467Z",
    fill: "url(#paint12_linear_335_6128)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M61.711 159.607C62.3113 157.922 63.8721 156.598 65.673 156.478C66.2733 156.478 66.8736 156.478 67.4739 156.718C68.9147 157.079 70.2354 158.042 70.9557 159.487C71.556 160.931 71.436 162.616 70.7156 164.061C69.9952 165.385 68.7946 166.468 67.3539 167.311C66.0332 168.033 64.4724 168.514 63.0317 168.996C62.7916 169.116 62.5514 168.996 62.3113 169.357C62.1912 169.598 62.3113 169.718 62.3113 170.079C62.3113 170.199 62.1912 170.32 62.0712 170.44C61.9511 170.56 61.8311 170.56 61.711 170.44C61.3508 170.32 60.9906 170.079 60.8706 169.838C60.1502 168.514 61.4709 168.033 62.4314 167.672C63.5119 167.311 64.5925 166.949 65.553 166.348C66.5135 165.746 67.2338 164.783 67.4739 163.7C67.7141 162.616 67.3539 161.292 66.3934 160.69C65.3128 159.968 63.8721 160.45 62.9116 161.292C62.5514 161.653 62.0712 162.376 61.711 161.653C61.3508 161.172 61.4709 160.089 61.711 159.607Z",
    fill: "url(#paint13_linear_335_6128)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8938 66.4433C29.5336 66.4433 29.2935 66.4433 28.8132 66.2025C27.4926 65.4803 26.2919 63.4341 26.1719 61.6286C26.1719 60.786 26.2919 60.1842 26.6521 59.8231H26.5321L27.4926 59.3416C27.8527 59.1009 28.453 59.1009 29.0533 59.462C30.374 60.1842 31.5746 62.2304 31.6947 64.0359C31.6947 65.1192 31.3345 65.8414 30.8543 66.0821L29.8938 66.5636V66.4433Z",
    fill: "url(#paint14_linear_335_6128)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6129 64.5174C30.4928 62.7119 29.4123 60.6657 27.9715 59.9435C26.6509 59.2213 25.5703 60.0638 25.5703 61.8693C25.6904 63.6748 26.7709 65.7211 28.2117 66.4433C29.6524 67.1655 30.733 66.3229 30.6129 64.5174Z",
    fill: "#BDBDBD"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0519 65.6013C29.172 65.6013 29.292 65.481 29.4121 65.3606C29.4121 65.3606 29.4121 65.3606 29.5322 65.3606C29.7723 65.1199 30.0124 64.6384 29.8923 64.1569C29.8923 62.9533 29.0519 61.6292 28.2115 61.1478C27.9714 61.0274 27.7312 60.907 27.6112 61.0274C27.4911 61.0274 27.3711 61.0274 27.3711 61.1478C27.251 61.1478 27.1309 61.2681 27.0109 61.2681C25.8103 61.8699 25.33 63.4347 25.9303 64.6384C26.2905 65.7217 27.7312 66.2032 29.0519 65.6013Z",
    fill: "#343434"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6184 70.8954C36.2582 70.8954 36.0181 70.8954 35.5378 70.6547C34.2172 69.9325 33.0165 67.8862 32.8965 66.0807C32.8965 65.2381 33.0165 64.6363 33.3767 64.2752H33.2567L34.2172 63.7938C34.5773 63.553 35.1777 63.553 35.778 63.9141C37.0986 64.6363 38.2992 66.6826 38.4193 68.4881C38.4193 69.5714 38.0591 70.2936 37.5789 70.5343L36.6184 71.0158V70.8954Z",
    fill: "url(#paint15_linear_335_6128)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3394 68.9696C37.2194 67.1641 36.1388 65.1178 34.6981 64.3956C33.3774 63.6734 32.2969 64.516 32.2969 66.3215C32.4169 68.127 33.4975 70.1732 34.9382 70.8954C36.379 71.6176 37.4595 70.7751 37.3394 68.9696Z",
    fill: "#BDBDBD"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7785 70.0535C35.8985 70.0535 36.0186 69.9331 36.1387 69.8128C36.1387 69.8128 36.1387 69.8128 36.2587 69.8128C36.4988 69.572 36.739 69.0906 36.6189 68.6091C36.6189 67.4054 35.7785 66.0814 34.938 65.5999C34.6979 65.4796 34.4578 65.3592 34.3377 65.4795C34.2177 65.4795 34.0976 65.4796 34.0976 65.5999C33.9776 65.5999 33.8575 65.7203 33.7374 65.7203C32.5368 66.3221 32.0566 67.8869 32.6569 69.0906C33.0171 70.1739 34.4578 70.6553 35.7785 70.0535Z",
    fill: "#343434"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M39.495 81.7298C39.3749 78.7206 37.4539 75.3504 35.1728 74.1467C32.8916 72.943 31.0907 74.3874 31.2108 77.3966C31.3308 80.4058 33.2518 83.7761 35.533 84.9797C37.8141 86.1834 39.615 84.739 39.495 81.7298Z",
    fill: "#313131"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M34.207 85.2183C33.8468 85.2183 33.4866 85.2182 33.0064 84.9775C31.3255 84.1349 30.0048 81.7276 29.8848 79.561C29.8848 78.5981 30.1249 77.8758 30.4851 77.5147H30.2449L32.286 76.4314C32.7662 76.1907 33.3665 76.1907 34.0869 76.5518C35.7678 77.3944 37.0884 79.8017 37.2085 81.9683C37.2085 83.172 36.8483 84.0146 36.128 84.3757L33.9669 85.459L34.207 85.2183Z",
    fill: "url(#paint16_linear_335_6128)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1686 82.9315C35.0486 80.7648 33.7279 78.3575 32.047 77.5149C30.3662 76.6724 29.1655 77.6353 29.2856 79.8019C29.4057 81.9685 30.7263 84.3759 32.4072 85.2185C33.968 86.061 35.2887 85.0981 35.1686 82.9315Z",
    fill: "#BDBDBD"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7669 85.3402C32.4068 85.3402 32.1666 85.3402 31.8064 85.0995C30.4858 84.3773 29.2852 82.331 29.2852 80.6459C29.2852 79.9237 29.4052 79.3219 29.7654 78.9608H29.6453L30.4858 78.4793C30.846 78.2386 31.4463 78.2386 31.9265 78.5997C33.2472 79.3219 34.4478 81.3681 34.4478 83.0532C34.4478 84.1365 34.0876 84.7384 33.6074 85.0995L32.6469 85.5809L32.7669 85.3402Z",
    fill: "url(#paint17_linear_335_6128)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4874 83.5347C33.3673 81.7292 32.2868 79.8034 30.9661 79.0812C29.6454 78.359 28.5648 79.2015 28.6849 81.0071C28.805 82.8126 29.8855 84.7384 31.2062 85.4606C32.5269 86.1828 33.6074 85.2199 33.4874 83.5347Z",
    fill: "#BDBDBD"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6258 88.4691C51.5058 85.4599 49.5848 82.0896 47.3036 80.886C45.0225 79.6823 43.2215 81.1267 43.3416 84.1358C43.4617 87.145 45.3827 90.5153 47.6638 91.719C49.945 92.9227 51.6258 91.4782 51.6258 88.4691Z",
    fill: "#313131"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3417 91.9604C45.9816 91.9604 45.6214 91.9604 45.1411 91.7197C43.4603 90.8771 42.1396 88.4698 42.0195 86.3032C42.0195 85.3402 42.2597 84.618 42.6198 84.2569H42.3797L44.4208 83.1736C44.901 82.9329 45.5013 82.9329 46.2217 83.294C47.9025 84.1366 49.2232 86.5439 49.3433 88.7105C49.3433 89.9142 48.9831 90.7568 48.2627 91.1179L46.1016 92.2012L46.3417 91.9604Z",
    fill: "url(#paint18_linear_335_6128)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3014 89.6736C47.1814 87.507 45.8607 85.0997 44.1798 84.2571C42.499 83.4146 41.2984 84.3775 41.4184 86.5441C41.5385 88.7107 42.8592 91.118 44.54 91.9606C46.1008 92.9236 47.3014 91.8403 47.3014 89.6736Z",
    fill: "#BDBDBD"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7806 92.2006C44.4204 92.2006 44.1803 92.2006 43.8201 91.9598C42.4994 91.2376 41.2988 89.1914 41.2988 87.5063C41.2988 86.7841 41.4189 86.1822 41.7791 85.8211H41.659L42.4994 85.3396C42.8596 85.0989 43.4599 85.0989 43.9402 85.46C45.2608 86.1822 46.4615 88.2285 46.4615 89.9136C46.4615 90.9969 46.1013 91.5987 45.621 91.9598L44.6605 92.4413L44.7806 92.2006Z",
    fill: "url(#paint19_linear_335_6128)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6221 90.2759C45.5021 88.4704 44.4215 86.5446 43.1008 85.8224C41.7802 85.1002 40.6996 85.9427 40.8197 87.7482C40.9397 89.5537 42.0203 91.4796 43.341 92.2018C44.6616 92.924 45.6221 92.0815 45.6221 90.2759Z",
    fill: "#BDBDBD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_335_6128",
    x1: 21.1135,
    y1: 112.083,
    x2: 99.0679,
    y2: 112.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1194,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4702,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5909,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7712,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_335_6128",
    x1: 43.5511,
    y1: 124.322,
    x2: 35.1657,
    y2: 124.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1194,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4702,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5909,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7712,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_335_6128",
    x1: 43.5511,
    y1: 120.82,
    x2: 35.1657,
    y2: 120.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_335_6128",
    x1: 54.8874,
    y1: 128.128,
    x2: 46.5019,
    y2: 128.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1194,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4702,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5909,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7712,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_335_6128",
    x1: 54.8874,
    y1: 124.624,
    x2: 46.5019,
    y2: 124.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_335_6128",
    x1: 64.9202,
    y1: 111.237,
    x2: 34.1869,
    y2: 111.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1194,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4702,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5909,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7712,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_335_6128",
    x1: 67.1964,
    y1: 96.6535,
    x2: 31.9045,
    y2: 96.6535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_335_6128",
    x1: 69.8487,
    y1: 143.82,
    x2: 80.2188,
    y2: 143.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_335_6128",
    x1: 17.8003,
    y1: 151.981,
    x2: 68.0133,
    y2: 184.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1194,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4702,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5909,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7712,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_335_6128",
    x1: 42.4879,
    y1: 152.623,
    x2: 18.717,
    y2: 152.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9341,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_335_6128",
    x1: 19.2895,
    y1: 139.744,
    x2: 41.9168,
    y2: 139.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2632,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7369,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A6A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_335_6128",
    x1: 38.5972,
    y1: 164.351,
    x2: 62.3681,
    y2: 164.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0658523,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_335_6128",
    x1: 39.1694,
    y1: 150.718,
    x2: 61.7968,
    y2: 150.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2631,
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7368,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_335_6128",
    x1: 60.5342,
    y1: 163.441,
    x2: 71.2927,
    y2: 163.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0658523,
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_335_6128",
    x1: 26.2135,
    y1: 62.8887,
    x2: 31.6412,
    y2: 62.8887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_335_6128",
    x1: 32.9371,
    y1: 67.31,
    x2: 38.3647,
    y2: 67.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_335_6128",
    x1: 29.9458,
    y1: 80.7556,
    x2: 37.3212,
    y2: 80.7556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_335_6128",
    x1: 29.1528,
    y1: 81.9256,
    x2: 34.4485,
    y2: 81.9256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_335_6128",
    x1: 42.0459,
    y1: 87.5496,
    x2: 49.4214,
    y2: 87.5496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_335_6128",
    x1: 41.252,
    y1: 88.7173,
    x2: 46.5477,
    y2: 88.7173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmall);
export default __webpack_public_path__ + "static/media/small.a6d18b624745e5acf8f9c25ba099081f.svg";
export { ForwardRef as ReactComponent };